import { render, staticRenderFns } from "./PdvCallCloseCashier.vue?vue&type=template&id=bb544052&scoped=true"
import script from "./PdvCallCloseCashier.vue?vue&type=script&lang=js"
export * from "./PdvCallCloseCashier.vue?vue&type=script&lang=js"
import style0 from "./PdvCallCloseCashier.vue?vue&type=style&index=0&id=bb544052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb544052",
  null
  
)

export default component.exports